import React from 'react';

import { Box, Typography } from '@sunwisesoftware/sunwise-ui';
import { useTranslation } from 'react-i18next';

import { useBreakpoint } from 'common/hooks';

import EmailFormatter from './EmailFormatter';
import NameFormatter from './NameFormatter';

const ProductColumns = () => {
    const { t } = useTranslation();
    const breakpoint = useBreakpoint();
    const nameColumn = [
        {
            align: 'left',
            field: 'business_name',
            headerName: t('Company'),
            renderCell: (params) => {
                const { row } = params;
                return <NameFormatter row={row} />;
            },
            width: 200,
        },
    ];

    let columns = [
        ...nameColumn,
        {
            align: 'left',
            field: 'owner_fullname',
            headerName: t('Owner'),
            width: 200,
        },
        {
            align: 'left',
            field: 'owner_email',
            headerName: t('Mail'),
            renderCell: (params) => {
                const { row } = params;
                return <EmailFormatter email={row?.owner_email} />;
            },
            width: 200,
        },
        {
            align: 'left',
            field: 'active_users',
            flex: 1,
            headerName: t('Active users'),
        },
        {
            align: 'left',
            field: 'country',
            flex: 1,
            headerName: t('Country'),
        },
        {
            align: 'left',
            field: 'contact_telephone',
            flex: 1,
            headerName: t('Phone'),
            renderCell: (params) => {
                const { row } = params;
                return (
                    <Box>
                        <Box>
                            <Typography variant="caption">
                                {row.contact_telephone}
                            </Typography>
                        </Box>
                        <Box>
                            <Typography variant="caption">
                                {row.contact_cellphone}
                            </Typography>
                        </Box>
                    </Box>
                );
            },
        },
        {
            align: 'left',
            field: 'created_at',
            headerName: t('Creation date'),
            renderCell: (params) => {
                const { row } = params;
                return (
                    <Typography variant="caption">{row.created_at}</Typography>
                );
            },
            width: 180,
        },
    ];

    if (['xs', 'sm'].includes(breakpoint)) {
        columns = nameColumn;
    }

    return columns;
};

export default ProductColumns;
